import * as React from "react";
import Tooltip from "./Ui/Tooltip";
import $ from 'jquery';
import { TApiParameter } from "../api/endpoints/Parameter";

type Props = {
	short?: true;
	labelOnly?: true;
	param: TApiParameter;
	placement?: "top" | "left" | "bottom" | "right"
};

export default (props => (
	<ParamLabel
		shortname={props.param.shortname}
		short={props.short}
		labelOnly={props.labelOnly}
		name={props.param.name}
		description={props.param.description}
		placement={props.placement}
	/>
)) as React.FC<Props>;

type ShortLabelProps = {
	shortname: string;
};

export const ShortParamLabel: React.FC<ShortLabelProps> = props => (
	<ParamLabel shortname={props.shortname} />
);

type LabelProps = {
	shortname: string;
	short?: true;
	labelOnly?: true;
	name?: string;
	description?: string;
	placement?: "top" | "left" | "bottom" | "right";
};

const ParamLabel: React.FC<LabelProps> = props => {
	const label = props.name && !props.short ? `${props.name} (${props.shortname})` : props.shortname;
	const header = props.name ? `${props.name} (${props.shortname})` : props.shortname;

	const tooltipCallback = React.useCallback(element => {
		$("a", $(element)).attr("target", "_blank");
	}, []);

	const button = (
		<>
			<Tooltip label={props.labelOnly ? label : undefined} placement={props.placement}>
				<div>
					<h3>{header}</h3>
					{props.description ? (
						<p dangerouslySetInnerHTML={{ __html: props.description }} ref={tooltipCallback} />
					) : (
							<p>Parameter description not found</p>
						)}
				</div>
			</Tooltip>
		</>
	);

	return props.labelOnly
		? button
		: (
			<span>
				{label}{button}
			</span>
		);
};
